// @flow

const shouldUseSecureToken = (protocol: string) => protocol === 'https:'

export const defaultCookieOptions = (protocol: string) => ({
  secure: shouldUseSecureToken(protocol),
  path: '/',
})
